<template>
  <!-- Calendar -->
  <div class="space-y-0.5">
    <!-- Months -->
    <div class="grid grid-cols-5 items-center gap-x-3 mx-1.5 pb-3">
      <!-- Prev Button -->
      <div class="col-span-1">
        <button @click="leftMonth" v-if="(range && range == 'desde') || !range" type="button"
          class="size-8 flex justify-center items-center text-gray-800 hover:bg-gray-100 rounded-full disabled:opacity-50 disabled:pointer-events-none dark:text-neutral-400 dark:hover:bg-neutral-800">
          <ChevronLeftIcon class="shrink-0 size-4" />
        </button>
      </div>
      <!-- End Prev Button -->
      <!-- Month / Year -->
      <div class="col-span-3 flex justify-center items-center gap-x-1">
        <div class="relative">
          <select
            :id="'calendar_meses_' + id"
            :data-hs-select="jsonmeses"
            class="hidden"
            @change="handleMonthChange">
            <template v-for="(month, i) in months" :key="month">
              <option selected v-if="i == mountActual" :value="i">{{ month }}</option>
              <option v-else :value="i">{{ month }}</option>
            </template>
          </select>
        </div>

        <span class="text-gray-800 dark:text-neutral-200">/</span>

        <div class="relative">
          <select
            :id="'calendar_year_' + id"
            :data-hs-select="jsonyear"
            class="hidden"
            @change="handleYearChange">
            <template v-for="year in years" :key="year">
              <option selected v-if="year == yearActual">{{ year }}</option>
              <option v-else>{{ year }}</option>
            </template>
          </select>
        </div>
      </div>
      <!-- End Month / Year -->
      <!-- Next Button -->
      <div class="col-span-1 flex justify-end">
        <button @click="rigthMonth" v-if="(range && range == 'hasta') || !range" type="button"
          class="size-8 flex justify-center items-center text-gray-800 hover:bg-gray-100 rounded-full disabled:opacity-50 disabled:pointer-events-none dark:text-neutral-400 dark:hover:bg-neutral-800">
          <ChevronRightIcon class="shrink-0 size-4"></ChevronRightIcon>
        </button>
      </div>
      <!-- End Next Button -->
    </div>
    <!-- Months -->
    <!-- Weeks -->
    <div class="flex pb-1.5">
      <span class="m-px w-10 block text-center text-sm text-gray-500 dark:text-neutral-500">
        Lu
      </span>
      <span class="m-px w-10 block text-center text-sm text-gray-500 dark:text-neutral-500">
        Ma
      </span>
      <span class="m-px w-10 block text-center text-sm text-gray-500 dark:text-neutral-500">
        Mi
      </span>
      <span class="m-px w-10 block text-center text-sm text-gray-500 dark:text-neutral-500">
        Ju
      </span>
      <span class="m-px w-10 block text-center text-sm text-gray-500 dark:text-neutral-500">
        vi
      </span>
      <span class="m-px w-10 block text-center text-sm text-gray-500 dark:text-neutral-500">
        Sa
      </span>
      <span class="m-px w-10 block text-center text-sm text-gray-500 dark:text-neutral-500">
        Do
      </span>
    </div>
    <!-- Weeks -->
    <!-- Days -->
    <template v-for="(sem, is) in semanas" :key="is">
      <div class="flex">
        <template v-for="(dia, ia) in sem" :key="ia">
          <div
            :class="range == 'desde' && yearActual == dia.year && mountActual == dia.month && dayActual == dia.day ? 'bg-gray-100 rounded-s-full dark:bg-neutral-800' : range == 'hasta' && yearActual == dia.year && (mountActual + 1) == dia.month && dayActual == dia.day ? 'bg-gray-100 rounded-e-full dark:bg-neutral-800' : yearActual == dia.year && mountActual == dia.month && ((range == 'desde' && dia.day > dayActual) || (range == 'hasta' && dia.day < dayActual)) ? 'bg-gray-100 first:rounded-s-full last:rounded-e-full dark:bg-neutral-800' : ''">
            <button @click="setValor(dia)"
              v-if="yearActual == dia.year && mountActual == dia.month && dayActual == dia.day"
              :disabled="dia.disabled"
              class="cursor-pointer m-px size-10 flex justify-center items-center bg-blue-600 border border-transparent text-sm font-medium text-white hover:border-blue-600 rounded-full dark:bg-blue-500 disabled:text-gray-300 disabled:pointer-events-none dark:hover:border-blue-500">
              {{ dia.day }}
            </button>
            <button @click="setValor(dia)" v-else-if="yearActual == dia.year && mountActual == dia.month"
              :disabled="isFutureDate(dia) || isAfterDate(dia) || dia.disabled"
              class="cursor-pointer m-px size-10 flex justify-center items-center border border-transparent text-sm text-gray-800 hover:border-blue-600 hover:text-blue-600 rounded-full disabled:text-gray-300 disabled:pointer-events-none dark:text-neutral-200 dark:hover:border-neutral-500 dark:disabled:text-neutral-600">
              {{ dia.day }}
            </button>
            <button v-else-if="range"
              disabled
              class="cursor-pointer m-px size-10 flex justify-center items-center border border-transparent text-sm text-gray-400 hover:border-blue-600 hover:text-blue-600 rounded-full disabled:text-gray-300 disabled:pointer-events-none dark:text-neutral-600 dark:hover:border-neutral-500">
              {{ dia.day }}
            </button>
            <button v-else
              :disabled="isFutureDate(dia) || isAfterDate(dia) || dia.disabled || yearActual !== dia.year || mountActual !== dia.month"
              class="cursor-pointer m-px size-10 flex justify-center items-center border border-transparent text-sm text-gray-400 hover:border-blue-600 hover:text-blue-600 rounded-full disabled:text-gray-300 disabled:pointer-events-none dark:text-neutral-600 dark:hover:border-neutral-500">
              {{ dia.day }}
            </button>
          </div>
        </template>
      </div>
    </template>
    <!-- Days -->
  </div>
  <!-- End Calendar -->
  <!-- Time -->
  <div :class="`mt-3 flex justify-center items-center gap-x-2 ${time ? '' : 'hidden'}`">
    <!-- Select -->
    <div class="relative">
      <select :id="'calendar_horas_' + id" :data-hs-select="jsonhora" class="hidden">
        <option value="0">0</option>
        <template v-for="i in 23" :key="i">
          <option selected v-if="i == horaactual" :value="i">{{ i }}</option>
          <option v-else :value="i">{{ i }}</option>
        </template>
      </select>
      <div class="absolute top-1/2 end-2 -translate-y-1/2">
        <ChevronUpDownIcon class="shrink-0 size-3 text-gray-500 dark:text-neutral-500"></ChevronUpDownIcon>
      </div>
    </div>
    <!-- End Select -->
    <span class="text-gray-800 dark:text-white">:</span>
    <!-- Select -->
    <div class="relative">
      <select :id="'calendar_min_' + id" :data-hs-select="jsonmin" class="hidden">
        <option value="00">00</option>
        <template v-for="i in 59" :key="i">
          <option selected v-if="i == minactual" :value="i > 9 ? i : `0${i}`">{{ i > 9 ? i : `0${i}` }}</option>
          <option v-else :value="i > 9 ? i : `0${i}`">{{ i > 9 ? i : `0${i}` }}</option>
        </template>
      </select>
      <div class="absolute top-1/2 end-2 -translate-y-1/2">
        <ChevronUpDownIcon class="shrink-0 size-3 text-gray-500 dark:text-neutral-500"></ChevronUpDownIcon>
      </div>
    </div>
    <!-- End Select -->
  </div>
  <!-- End Time -->
</template>
<script setup lang="ts">
import { ChevronLeftIcon, ChevronRightIcon, ChevronUpDownIcon } from '@heroicons/vue/24/outline'
import { watch, ref, nextTick, onMounted, onUnmounted, type ModelRef } from 'vue'
import { years, months, restarUnMes, sumarUnMes } from '@/modules/Core/usings/generales'
import type { IDia } from '@/modules/Core/interfaces'
const yearsFiltered = ref<number[]>([])

const model = defineModel<string>()
const props = defineProps({
  id: String,
  closeOnSelect: Boolean,
  footer: Boolean,
  time: Boolean,
  range: String,
  blockFutureDates: {
    type: Boolean,
    default: false
  },
  blockAfterDates: {
    type: Boolean,
    default: false
  }
})
const { time = false } = props
function closeCalendarClick() {
  const el = document.getElementById('calendar_content_' + props.id)
  el && el.classList.add("hidden")
}
const yearActual = ref<number>(new Date().getFullYear())
const mountActual = ref<number>(new Date().getMonth())
const dayActual = ref<number>(new Date().getDate())
const horaactual = ref<number | null>(null)
const minactual = ref<number | null>(null)
const daysemanaActual = ref(null)
const semanas = ref<Array<IDia[]>>([[], [], [], [], [], []])
const isFutureDate = (dia: IDia): boolean => {
  if (!props.blockFutureDates) return false
  const today = new Date()
  const checkDate = new Date(dia.year, dia.month, dia.day)
  return checkDate > today
}
const isAfterDate = (dia: IDia): boolean => {
  if (!props.blockAfterDates) return false
  const today = new Date()
  const checkDate = new Date(dia.year, dia.month, dia.day)
  return checkDate < today
}
const setValor = (day: IDia) => {
  if (isUpdating) return
  if (props.blockFutureDates) {
    const today = new Date()
    const checkDate = new Date(day.year, day.month, day.day)
    if (checkDate > today) {
      model.value = ''
      return
    }
  }
  if (props.blockAfterDates) {
    const today = new Date()
    const checkDate = new Date(day.year, day.month, day.day)
    if (checkDate < today) {
      model.value = ''
      return
    }
  }
  dayActual.value = day.day
  mountActual.value = day.month
  yearActual.value = day.year
  const month = day.month + 1
  let fechaFinal = `${day.year}-${month < 10 ? '0' : ''}${month}-${day.day < 10 ? '0' : ''}${day.day}`
  if (time) {
    const selectHour = document.getElementById('calendar_horas_' + props.id) as HTMLSelectElement
    const selectMin = document.getElementById('calendar_min_' + props.id) as HTMLSelectElement
    fechaFinal = `${fechaFinal} ${selectHour.value}:${selectMin.value}`
  }
  model.value = fechaFinal
  if (props.closeOnSelect) {
    closeCalendarClick()
  }
}
const mapDate = (nuevasPropiedades: string | undefined) => {
  if (!nuevasPropiedades) {
    return getCurrentDate()
  }
  try {
    const [fecha, horamin] = nuevasPropiedades.split(' ')
    const [year, month, day] = fecha.split('-').map(Number)
    if (
      isNaN(year) || isNaN(month) || isNaN(day) ||
      month < 1 || month > 12 || day < 1 || day > 31
    ) {
      throw new Error('Fecha inválida')
    }
    const parsed = {
      year,
      month: month - 1,
      day,
      hour: horamin ? Number(horamin.split(':')[0]) : null,
      min: horamin ? Number(horamin.split(':')[1]) : null,
    }
    return parsed
  } catch (error) {
    console.error('Error al parsear fecha, usando fecha actual')
    return getCurrentDate()
  }
}

const getCurrentDate = () => {
  const now = new Date()
  return {
    year: now.getFullYear(),
    month: now.getMonth(),
    day: now.getDate(),
    hour: time ? now.getHours() : null,
    min: time ? now.getMinutes() : null
  }
}
let isUpdating = false
watch(model as ModelRef<string>, async (nuevasPropiedades: string) => {
  if (isUpdating || !nuevasPropiedades) return
  try {
    isUpdating = true
    const parsed = mapDate(nuevasPropiedades)
    await cargarFecha(parsed)
  } finally {
    isUpdating = false
  }
}, { deep: true })

const cargarFecha = async (parsedDate: {
  year: number
  month: number
  day?: number | null
  hour?: number | null
  min?: number | null
}) => {
  if (!parsedDate) {
    console.warn("No se proporcionó una fecha válida, usando fecha actual")
    parsedDate = getCurrentDate()
  }
  try {
    if (!parsedDate.year || isNaN(parsedDate.year)) {
      parsedDate.year = new Date().getFullYear()
    }
    if (parsedDate.month === null || parsedDate.month === undefined || isNaN(parsedDate.month)) {
      parsedDate.month = new Date().getMonth()
    }
    parsedDate.month = Math.max(0, Math.min(11, parsedDate.month))
    yearActual.value = parsedDate.year
    mountActual.value = parsedDate.month
    const ultimoDiaMes = new Date(parsedDate.year, parsedDate.month + 1, 0).getDate()
    if (!parsedDate.day || isNaN(parsedDate.day)) {
      dayActual.value = new Date().getDate()
    } else {
      dayActual.value = Math.min(parsedDate.day, ultimoDiaMes)
    }
    if (time) {
      if (!parsedDate.hour || isNaN(parsedDate.hour)) {
        horaactual.value = new Date().getHours()
      } else {
        horaactual.value = Math.max(0, Math.min(23, parsedDate.hour))
      }
      if (!parsedDate.min || isNaN(parsedDate.min)) {
        minactual.value = new Date().getMinutes()
      } else {
        minactual.value = Math.max(0, Math.min(59, parsedDate.min))
      }
    }
    await nextTick()
    calcularCalendario()
    await nextTick()
    const selectYear = document.getElementById('calendar_year_' + props.id) as HTMLSelectElement
    const selectMonth = document.getElementById('calendar_meses_' + props.id) as HTMLSelectElement
    if (selectYear && selectMonth) {
      try {
        selectYear.value = yearActual.value.toString()
        selectMonth.value = mountActual.value.toString()
        const hsYear = (window as any).HSSelect.getInstance(selectYear)
        const hsMonth = (window as any).HSSelect.getInstance(selectMonth)
        if (hsYear) hsYear.destroy()
        if (hsMonth) hsMonth.destroy()
        new (window as any).HSSelect(selectYear)
        new (window as any).HSSelect(selectMonth)
      } catch (selectError) {
        console.warn("Error al actualizar selectores:", selectError)
      }
    }
  } catch (error) {
    console.error("Error al cargar fecha:", error)
    const defaultDate = getCurrentDate()
    yearActual.value = defaultDate.year
    mountActual.value = defaultDate.month
    dayActual.value = defaultDate.day
    calcularCalendario()
  }
}

const leftMonth = () => {
  if (mountActual.value != null) {
    let fecha: Date = time && horaactual.value && minactual.value ? new Date(yearActual.value, mountActual.value, 1, horaactual.value, minactual.value) : new Date(yearActual.value, mountActual.value, 1)
    fecha = restarUnMes(fecha)
    cargarFecha(mapDate(time ? fecha.yyyymmddhhmm() : fecha.yyyymmdd()))
  }
}
const rigthMonth = () => {
  if (mountActual.value != null) {
    let fecha: Date = time && horaactual.value && minactual.value ? new Date(yearActual.value, mountActual.value, 1, horaactual.value, minactual.value) : new Date(yearActual.value, mountActual.value, 1)
    fecha = sumarUnMes(fecha)
    cargarFecha(mapDate(time ? fecha.yyyymmddhhmm() : fecha.yyyymmdd()))
  }
}
const calcularCalendario = () => {
  try {
    if (mountActual.value === null) {
      mountActual.value = new Date().getMonth()
    }
    if (!yearActual.value) {
      yearActual.value = new Date().getFullYear()
    }

    semanas.value = [[], [], [], [], [], []]
    const mesSeleccionado = mountActual.value as number
    const yearSeleccionado = yearActual.value
    const primerDia = new Date(yearSeleccionado, mesSeleccionado, 1)
    const totalDias = new Date(yearSeleccionado, mesSeleccionado + 1, 0).getDate()
    const inicioMes = primerDia.getDay()
    const posicionInicial = inicioMes === 0 ? 6 : inicioMes - 1
    let diaActual = 1
    let totalCeldas = 42
    for (let i = 0; i < totalCeldas; i++) {
      const semana = Math.floor(i / 7)
      if (i < posicionInicial) {
        const diaAnterior = new Date(yearSeleccionado, mesSeleccionado, -posicionInicial + i + 1)
        semanas.value[semana].push({
          year: diaAnterior.getFullYear(),
          month: diaAnterior.getMonth(),
          day: diaAnterior.getDate(),
          disabled: true
        })
      } else if (diaActual <= totalDias) {
        semanas.value[semana].push({
          year: yearSeleccionado,
          month: mesSeleccionado,
          day: diaActual++,
          disabled: false
        })
      } else {
        const diaSiguiente = new Date(yearSeleccionado, mesSeleccionado + 1, diaActual++ - totalDias)
        semanas.value[semana].push({
          year: diaSiguiente.getFullYear(),
          month: diaSiguiente.getMonth(),
          day: diaSiguiente.getDate(),
          disabled: true
        })
      }
    }
  } catch (error) {
    console.error('Error al calcular calendario:', error)
    mountActual.value = new Date().getMonth()
    yearActual.value = new Date().getFullYear()
    dayActual.value = new Date().getDate()
  }
}
const jsonmeses = JSON.stringify({
  "placeholder": "Select month",
  "viewport": '#calendar_content_' + props.id,
  "toggleTag": "<button type=\"button\"></button>",
  "toggleClasses": "hs-select-disabled:pointer-events-none hs-select-disabled:opacity-50 relative flex text-nowrap w-full cursor-pointer text-start font-medium text-gray-800 hover:text-gray-600 focus:outline-none focus:text-gray-600 before:absolute before:inset-0 before:z-[1] dark:text-neutral-200 dark:hover:text-neutral-300 dark:focus:text-neutral-300",
  "dropdownClasses": "mt-2 z-50 w-32 max-h-72 p-1 space-y-0.5 bg-white border border-gray-400 rounded-lg shadow-lg overflow-hidden overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300 dark:[&::-webkit-scrollbar-track]:bg-neutral-700 dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500 dark:bg-neutral-900 dark:border-neutral-700",
  "optionClasses": "p-2 w-full text-sm text-gray-800 cursor-pointer hover:bg-gray-100 rounded-lg focus:outline-none focus:bg-gray-100 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:text-neutral-200 dark:focus:bg-neutral-800",
  "optionTemplate": "<div class=\"flex justify-between items-center w-full\"><span data-title></span><span class=\"hidden hs-selected:block\"><svg class=\"shrink-0 size-3.5 text-gray-800 dark:text-neutral-200\" xmlns=\"http:.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><polyline points=\"20 6 9 17 4 12\"/></svg></span></div>"
})
const jsonyear = JSON.stringify({
  "placeholder": "Select year",
  "viewport": '#calendar_content_' + props.id,
  "toggleTag": "<button type=\"button\"></button>",
  "toggleClasses": "hs-select-disabled:pointer-events-none hs-select-disabled:opacity-50 relative flex text-nowrap w-full cursor-pointer text-start font-medium text-gray-800 hover:text-gray-600 focus:outline-none focus:text-gray-600 before:absolute before:inset-0 before:z-[1] dark:text-neutral-200 dark:hover:text-neutral-300 dark:focus:text-neutral-300",
  "dropdownClasses": "mt-2 z-50 w-20 max-h-72 p-1 space-y-0.5 bg-white border border-gray-400 rounded-lg shadow-lg overflow-hidden overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300 dark:[&::-webkit-scrollbar-track]:bg-neutral-700 dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500 dark:bg-neutral-900 dark:border-neutral-700",
  "optionClasses": "p-2 w-full text-sm text-gray-800 cursor-pointer hover:bg-gray-100 rounded-lg focus:outline-none focus:bg-gray-100 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:text-neutral-200 dark:focus:bg-neutral-800",
  "optionTemplate": "<div class=\"flex justify-between items-center w-full\"><span data-title></span><span class=\"hidden hs-selected:block\"><svg class=\"shrink-0 size-3.5 text-gray-800 dark:text-neutral-200\" xmlns=\"http:.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><polyline points=\"20 6 9 17 4 12\"/></svg></span></div>"
})
const jsonhora = JSON.stringify({
  "placeholder": "Select option...",
  "viewport": '#calendar_content_' + props.id,
  "toggleTag": "<button type=\"button\"></button>",
  "toggleClasses": "hs-select-disabled:pointer-events-none hs-select-disabled:opacity-50 relative py-1 px-2 pe-6 flex text-nowrap w-full cursor-pointer bg-white border border-gray-400 rounded-lg text-start text-sm focus:border-blue-500 focus:ring-blue-500 before:absolute before:inset-0 before:z-[1] dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400",
  "dropdownClasses": "mt-2 z-50 w-full min-w-24 max-h-72 p-1 space-y-0.5 bg-white border border-gray-400 rounded-lg overflow-hidden overflow-y-auto dark:bg-neutral-900 dark:border-neutral-700",
  "optionClasses": "hs-selected:bg-gray-100 dark:hs-selected:bg-neutral-800 py-2 px-4 w-full text-sm text-gray-800 cursor-pointer hover:bg-gray-100 rounded-lg focus:outline-none focus:bg-gray-100 dark:hs-selected:bg-gray-700 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:text-neutral-200 dark:focus:bg-neutral-800",
  "optionTemplate": "<div class=\"flex justify-between items-center w-full\"><span data-title></span></div>"
})
const jsonmin = JSON.stringify({
  "placeholder": "Select option...",
  "viewport": '#calendar_content_' + props.id,
  "toggleTag": "<button type=\"button\"></button>",
  "toggleClasses": "hs-select-disabled:pointer-events-none hs-select-disabled:opacity-50 relative py-1 px-2 pe-6 flex text-nowrap w-full cursor-pointer bg-white border border-gray-400 rounded-lg text-start text-sm focus:border-blue-500 focus:ring-blue-500 before:absolute before:inset-0 before:z-[1] dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400",
  "dropdownClasses": "mt-2 z-50 w-full min-w-24 max-h-72 p-1 space-y-0.5 bg-white border border-gray-400 rounded-lg overflow-hidden overflow-y-auto dark:bg-neutral-900 dark:border-neutral-700",
  "optionClasses": "hs-selected:bg-gray-100 dark:hs-selected:bg-neutral-800 py-2 px-4 w-full text-sm text-gray-800 cursor-pointer hover:bg-gray-100 rounded-lg focus:outline-none focus:bg-gray-100 dark:hs-selected:bg-gray-700 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:text-neutral-200 dark:focus:bg-neutral-800",
  "optionTemplate": "<div class=\"flex justify-between items-center w-full\"><span data-title></span></div>"
})
watch(model as ModelRef<string>, async (nuevasPropiedades) => {
  if (!nuevasPropiedades) return
  const parsed = mapDatePartial(nuevasPropiedades.toString())
  if (parsed) await cargarFecha(parsed)
})
const mapDatePartial = (value: string) => {
  const [fecha, hora] = value.split(" ")
  const [year, month, day] = fecha.split("-").map(Number)
  return {
    year: year || new Date().getFullYear(),
    month: (month > 0 ? month - 1 : new Date().getMonth()) || 0,
    day: day || 1,
    hour: hora ? Number(hora.split(":")[0]) : null,
    min: hora ? Number(hora.split(":")[1]) : null,
  }
}

const handleMonthChange = () => {
  const selectMonth = document.getElementById('calendar_meses_' + props.id) as HTMLSelectElement
  if (selectMonth) {
    mountActual.value = parseInt(selectMonth.value)
    updateInputValue()
  }
}

const handleYearChange = () => {
  const selectYear = document.getElementById('calendar_year_' + props.id) as HTMLSelectElement
  if (selectYear) {
    yearActual.value = parseInt(selectYear.value)
    updateInputValue()
  }
}

const updateInputValue = () => {
  if (isUpdating) return
  if (mountActual.value !== null && dayActual.value) {
    try {
      isUpdating = true
      const month = (mountActual.value + 1)
      let fechaFinal = `${yearActual.value}-${month < 10 ? '0' : ''}${month}-${dayActual.value < 10 ? '0' : ''}${dayActual.value}`

      if (time && horaactual.value !== null && minactual.value !== null) {
        const selectHour = document.getElementById('calendar_horas_' + props.id) as HTMLSelectElement
        const selectMin = document.getElementById('calendar_min_' + props.id) as HTMLSelectElement
        fechaFinal = `${fechaFinal} ${selectHour.value}:${selectMin.value}`
      }
      model.value = fechaFinal
      calcularCalendario()
    } finally {
      isUpdating = false
    }
  }
}

onMounted(async () => {
  try {
    const initialDate = model.value ? mapDate(model.value) : getCurrentDate()
    await cargarFecha(initialDate)
    const selectMonth = document.getElementById('calendar_meses_' + props.id)
    const selectYear = document.getElementById('calendar_year_' + props.id)
    selectMonth?.addEventListener('change', handleMonthChange)
    selectYear?.addEventListener('change', handleYearChange)
  } catch (error) {
    console.error('Error en la inicialización del calendario:', error)
    await cargarFecha(getCurrentDate())
  }
})
</script>
